import React from "react";
import { Logger, LoggerContext } from "./context/logging";
import Routers from "./Route";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import FilterProvider from "./_helper/Ecommerce/Filter/FilterProvider";
import UserProvider from "./_helper/User/UserProvider";

const App = () => {
  const logger = new Logger();

  logger.addClient("moengage");
  logger.addClient("9e716b5e98ca65892693ac00d329efd1", "amplitude");

  return (
    <div className="App">
      <UserProvider>
        <CustomizerProvider>
          <FilterProvider>
            <AnimationThemeProvider>
              <LoggerContext.Provider value={logger}>
                <Routers />
              </LoggerContext.Provider>
            </AnimationThemeProvider>
          </FilterProvider>
        </CustomizerProvider>
      </UserProvider>
    </div>
  );
};

export default App;
